export type RuntimeConfig = {
  sentryDsn?: string;
  sentryTracesSampleRate?: string;
  sentryEnvironment?: string;
  sentryRelease?: string;
};

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
    SENTRY_RELEASE?: { id?: string };
  }
}

const runtimeOverride: RuntimeConfig =
  (typeof window === 'undefined' ? undefined : window.__RUNTIME_CONFIG__) ?? {};

// @sentry/vite-plugin writes the git SHA to window.SENTRY_RELEASE; it is what
// the SDK would pick as the release on its own.
const buildTimeRelease = typeof window === 'undefined' ? undefined : window.SENTRY_RELEASE?.id;

const isBlank = (value: string | undefined): boolean =>
  typeof value !== 'string' || value.trim() === '';

const resolve = (
  override: string | undefined,
  buildTime: string | undefined,
): string | undefined => (isBlank(override) ? buildTime : override);

const toSampleRate = (raw: string | undefined): number => {
  const rate = Number(raw);
  return Number.isFinite(rate) && rate >= 0 && rate <= 1 ? rate : 0;
};

export const sentryDsn = resolve(runtimeOverride.sentryDsn, import.meta.env.VITE_SENTRY_DSN);

export const sentryTracesSampleRate = toSampleRate(
  resolve(runtimeOverride.sentryTracesSampleRate, import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),
);

export const sentryEnvironment = resolve(
  runtimeOverride.sentryEnvironment,
  import.meta.env.SENTRY_ENV,
);

export const sentryRelease = resolve(runtimeOverride.sentryRelease, buildTimeRelease);
